import emailProviders from "email-providers/all.json";

export const getInitials = (
  name: string | undefined | null,
): string | undefined => {
  if (!name || typeof name !== "string") {
    return "";
  }

  const initials = name.split(" ");

  if (initials.length === 2) {
    const first = initials[0]?.[0] || "";
    const second = initials[1]?.[0] || "";
    return `${first}${second}`.toUpperCase();
  }

  return initials[0]?.[0]?.toUpperCase();
};

export const isPersonalEmail = (email: string) => {
  const domain = email.split("@").pop();
  return emailProviders.includes(domain || "");
};

/**
 * Convert a user's admin_type to a boolean indicating whether they have write admin privileges.
 * Possible values are null, "readonly", "readwrite", "master", and "readsupport"
 */
export const isAdminWithWritePrivilege = (adminType?: string | null) => {
  switch (adminType) {
    case "readwrite":
    case "master":
      return true;
    case "readonly":
    case "readsupport":
    default:
      return false;
  }
};

const HIGHTOUCH_STAFF_ADMIN_TYPES = new Set([
  "master",
  "readwrite",
  "readonly",
  "readsupport",
]);

/** Hightouch staff with any support admin role (readwrite, readonly, readsupport, master). */
export const isHightouchStaffUser = (
  adminType?: string | null,
  options?: { pretendImNotAHightouchAdmin?: boolean },
): boolean =>
  !options?.pretendImNotAHightouchAdmin &&
  HIGHTOUCH_STAFF_ADMIN_TYPES.has(adminType ?? "");
